import { useEffect } from 'react';
import { $ } from '../../utils/dom';
import { SCROLL_THRESHOLD } from './constants';

/**
 * Toggle a CSS class on body based on scroll position
 */
export const useScrollClassToggle = (
  className: string = 'scrolling',
  threshold: number = SCROLL_THRESHOLD
) => {
  useEffect(() => {
    const handleScroll = () => {
      const body = $('body');
      if (!body) return;

      if (window.scrollY > window.innerHeight * threshold) {
        body.classList.add(className);
      } else {
        body.classList.remove(className);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [className, threshold]);
};

export default useScrollClassToggle;
